import React from "react";
import {connect} from "react-redux";

export function PartiesWrapper(props) {

    return (
        <div className={"doc-section " + (props.className ? " " + props.className : "")} >
            <div className="label title2 heavy">
                {props.section}
            </div>
            {props.children}
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(PartiesWrapper);